import AppRoutes from "AppRoutes";
import { useBoard, useLayout, useTranslations } from "providers";

export const BreadCrumbToggleBoardSettings: React.FC = () => {
  const i18n = useTranslations();
  const { handleNavClick } = useLayout();

  const { board, boardPermissions } = useBoard();
  if (!board) {
    return null;
  }

  const { canEdit } = boardPermissions;
  if (!canEdit) {
    return null;
  }

  const isSettings = window.location.pathname.includes("settings");
  const url = isSettings ? AppRoutes.toBoardMeetings(board) : AppRoutes.toBoardSettings(board);
  const label = isSettings ? i18n.Actions_GoToMeetings : i18n.Actions_GoToBoard;

  return (
    <div className="cta">
      <a className="d-block" id="breadcrumb-open-board-settings" onClick={() => handleNavClick(url)}>
        <span className="sbb-arrow-cta">{label}</span>
      </a>
    </div>
  );
};
